// extracted by mini-css-extract-plugin
export default {"wrapper":"LanguagePicker_wrapper__wr3O6","langSelector":"LanguagePicker_langSelector__sm84r","flag":"LanguagePicker_flag__tiYBe"};